// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1OZyd","large":"styles_large__2o0K9"};